import React, { useState } from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';
import { useLanguage } from '../../contexts/LanguageContext';

const PrintableCard = React.forwardRef(({ employee, logo, backgroundColor, backgroundImage, fontColor, logoSize, photoSize, qrSize }, ref) => {
  const { translate } = useLanguage();
  const [photoLoaded, setPhotoLoaded] = useState(false);

  return (
    <Box
      ref={ref}
      sx={{
        p: 2,
        textAlign: 'center',
        width: '300px', // Fixed width
        height: '450px', // Fixed height
        border: '1px solid #000',
        borderRadius: '8px',
        backgroundColor: backgroundColor || '#ffffff', // Use background color
        backgroundImage: backgroundImage ? `url(${URL.createObjectURL(backgroundImage)})` : 'none', // Use background image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: fontColor, // Apply font color
        overflow: 'hidden', // Prevent content from overflowing
      }}
    >
      {/* Company Logo */}
      {logo && (
        <img
          src={URL.createObjectURL(logo)} // Display uploaded logo
          alt={translate('printableCard.companyLogo')}
          style={{ width: `${logoSize}px`, height: 'auto', marginBottom: '16px' }}
        />
      )}

      {/* Employee Photo */}
      <Avatar
        src={employee?.photo_url}
        sx={{ width: photoSize, height: photoSize, mx: 'auto', mb: 2 }}
        imgProps={{ onLoad: () => setPhotoLoaded(true) }} // Ensure photo is loaded
      />

      {/* Employee Name */}
      <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
        {employee?.full_name}
      </Typography>

      {/* Employee Position */}
      <Typography variant="body1" sx={{ mb: 2 }}>
        {employee?.position}
      </Typography>

      {/* Schedule */}
      <Typography variant="body2" sx={{ mb: 2 }}>
        {translate('printableCard.schedule')}: {employee?.schedule}
      </Typography>

      {/* Work Days */}
      <Typography variant="body2" sx={{ mb: 2 }}>
        {translate('printableCard.workDays')}: {Array.isArray(employee?.work_days) ? employee.work_days.join(', ') : ''}
      </Typography>

      {/* QR Code */}
      <Box sx={{ mt: 2 }}>
        <QRCodeCanvas value={employee?.qr_code || ''} size={qrSize} />
      </Box>
    </Box>
  );
});

export default PrintableCard;